
  //import {Vue} from "vue-property-decorator";
  //import Component from "vue-class-component";
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import { Alert } from "@/addons/Alert";
  import { http } from "@/config/HttpClient";
  import { DateTime } from "luxon";
  import { useConsultorioStore } from '@/store/consultorioStore';
  import { globalStore } from '@/store/globalStore';
  import { consultorioService } from '@/services/ConsultorioService';
	import { AxiosResponse } from "axios";
  
  @Component({
    name: "FichaPeriodoncia",
  })
  
  export default class FichaPeriodoncia extends Vue {
    @Prop() paciente_id!: any
    @Prop() cita!: any
		@Prop() swEditar!: any
		@Prop() ficha_selected!: any
    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    private tab:any = null;
    piezas = [];
		pieza_dental = null;
		antecedentes = '';
		estado_actual = '';
    valid = true;
		preguntas = [];
		cerrada = [];
		respuestas = [];
		cepillados = ['Tecnica de Bass','Tecnica de Charterss'];
		tipos_cepillo = ['Suave','Media','Dura'];
		tiempos_cepillo = ['Semanas','Meses','Años']
		tipos_pasta = ['Colgate','Foramen','Pepsodent','Oral B', 'Kin', 'Otros']
		antecedentes_familiares = ['Padre','Madre','Hermanos'];

		private fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
    get tratamientos(): any {
      return this.consultorioStore.tratamientos;
    }
		get loading(): boolean {
      return this.consultorioStore.loading;
    }
		get tipo_ficha(): any {
			let tipo = '';
			if(this.cita && this.cita.tratamiento_id == 8){
				tipo = 'PERIODONCIA'
			}
			return tipo;
		}
    mounted(){
      //this.getPiezas();
			this.getPreguntasEndodoncia()
			this.getRespuestas();
    }
    
    
    async getPiezas() {
			await http.get('get-piezas').subscribe({
				next: (response:AxiosResponse) => {
					this.piezas = response.data;
				},
			})
		}
		async getPreguntasEndodoncia() {
			this.consultorioStore.loading = true;
			await http.get('get-preguntas-endodoncia',{params: {ficha: 'PERIODONCIA'}}).subscribe({
				next: (response:AxiosResponse) => {
					this.preguntas = response.data;
					this.consultorioStore.loading = false;
				},
			})
		}

		select_opciones(tipo:string,pregunta:string) {
		let opciones = []
		switch (tipo) {
			case 'CERRADA':
				opciones = this.cerrada
				break;
			
			default:
				break;
		}
		return opciones;
	}
    guardar(){
      if (!this.$refs.form.validate()) {
        Alert.warning( `Lene todos los campos obligatorios (*)`)
        return;
      }
			let data = {
				pieza_dental_id: this.pieza_dental,
				paciente_id: this.paciente_id,
				antecedentes: this.antecedentes,
				estado_actual: this.estado_actual,
				cita_id: this.cita.id,
				preguntas_x_clasificacion: this.preguntas,
				tipo_ficha: this.tipo_ficha,
				ficha_id: this.ficha_selected?this.ficha_selected.id:null
			}
      if(!this.swEditar){
				
				
        Alert.confirm(`Se realizará el registro de la ficha`, 'Registrar nueva Ficha?').then(async result => {
          if(result.isConfirmed){
            await this.consultorioService.registrarFicha(data)
            
          }
        })
      }else {
				
        Alert.confirm(`Se realizará la modificacion de la ficha`, 'Modificar ficha?').then(async result => {
          if(result.isConfirmed){
            await this.consultorioService.updateFicha(data)
          }
        })
      }
      
    }

		async cargarDatos(){
			if(this.swEditar){
				this.pieza_dental = this.ficha_selected.pieza_dental_id;
				this.antecedentes = this.ficha_selected.antecedentes;
				this.estado_actual = this.ficha_selected.estado_actual;

				this.preguntas.forEach(element => {
						element.preguntas.forEach(el => {
						let respuesta = this.respuestas.find(val => val.pregunta_id == el.id)
						if(respuesta){
							//console.log(respuesta)
							el.respuesta = respuesta.respuesta;
							el.observacion = respuesta.observacion
							console.log(el)
						}
					});
				});

			}
		}

		async getRespuestas() {
		await http.get(`get-respuestas-paciente/${this.paciente_id}`).subscribe({
			next: (response:AxiosResponse) => {
				this.respuestas = response.data;
				this.cargarDatos();
			},
		})
	}
  
    
    
  }
  
  